
const CustomStyle = {
    multiselect: {
        '& .MuiInputBase-root': {
            fontSize: '13px',
            boxShadow: 'none',
            borderWidth: '1px',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderWidth: '1px',
                borderColor: '#afc0f7',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ced4da',
            },
            '.MuiOutlinedInput-notchedOutline': {
                borderColor: '#ced4da',
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: '1px',
            borderColor: '#afc0f7',
        },
        '& .MuiFormHelperText-root': {
            fontSize: '12px',
        },
    },
    singleselect: {
        '& .MuiInputBase-root': {
            fontSize: '13px',
            boxShadow: 'none',
            borderWidth: '1px',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderWidth: '1px',
                borderColor: '#afc0f7',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#ced4da',
            },
            '.MuiOutlinedInput-notchedOutline': {
                borderColor: '#ced4da',
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: '1px',
            borderColor: '#afc0f7',
        },
        '& .MuiFormHelperText-root': {
            fontSize: '12px',
        },
    },
};

// Common Autocomplete dropdown styles
export const autocompleteDropdownStyles = {
    ListboxProps: {
        sx: {
            fontFamily: 'Poppins, sans-serif',
            fontSize: '13px',
            '& .MuiAutocomplete-option': {
                fontFamily: 'Poppins, sans-serif',
                fontSize: '13px',
            },
        },
    },
    renderOption: (props: any, option: any, getOptionLabel?: (option: any) => string) => {
        const { key, ...rest } = props;
        return (
            <li
                key={key}
                {...rest}
                style={{
                    fontFamily: 'Poppins, sans-serif',
                    fontSize: '13px',
                }}
            >
                {getOptionLabel ? getOptionLabel(option) : option?.toString() || ''}
            </li>
        );
    },
    // Common input field styles for selected value
    inputSx: {
        fontFamily: 'Poppins, sans-serif',
        '& input': {
            fontFamily: 'Poppins, sans-serif',
            fontSize: '13px',
        },
        '& .MuiInputBase-input::placeholder': {
            fontFamily: 'Poppins, sans-serif',
            fontSize: '13px',
        },
    },
};

export default CustomStyle;
